import { render, staticRenderFns } from "./OrgSummaryCard.vue?vue&type=template&id=44fbe01a&scoped=true&"
import script from "./OrgSummaryCard.vue?vue&type=script&lang=js&"
export * from "./OrgSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./OrgSummaryCard.vue?vue&type=style&index=0&id=44fbe01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fbe01a",
  null
  
)

export default component.exports